import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ResponsiveContainer from './ResponsiveContainer';

function PersonaSelectionPage({ personalDetails, setPersonalDetails, t }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [persona, setPersona] = useState(personalDetails.persona || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
 
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!persona || !persona.trim()) {
      alert(t('pleaseSelectPersona'));
      return;
    }
    
    setIsSubmitting(true);
    
    // Update the personal details with the email
    setPersonalDetails({ ...personalDetails, persona: persona });
    
    // Navigate to the goal selection page
    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/goal-selection');
    }, 500);
  };

  return (
    <ResponsiveContainer>
      <div className="min-h-[calc(100vh-100px)] bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-semibold text-center mb-6">{t('selectPersona')}</h2>
          
          <p className="text-gray-600 mb-6 text-center">
            {t('selectPersona')}
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <select
                name="persona"
                value={persona}
                onChange={(e) => setPersona(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">{t('pleaseSelectPersona')}</option>
                <option value="1">Manny</option>
                <option value="2">Bonnie</option>
                <option value="3">Bouke</option>
                <option value="4">Rudy</option>
                <option value="5">Max</option>
                <option value="6">Mia</option>
                <option value="7">Other</option>
              </select>
            </div>
            
            <div className="flex justify-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#d0a949] hover:bg-[#a6873a] text-white py-3 px-6 rounded-lg shadow transition duration-200 flex items-center justify-center disabled:opacity-50"
              >
                {isSubmitting ? (
                  <span className="inline-block animate-spin mr-2">⏳</span>
                ) : null}
                {t('next')}
              </button>
            </div>
          </form>
          
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-gray-500 hover:text-gray-700 text-sm"
            >
              {t('back')}
            </button>
          </div>
        </div>
      </div>
    </ResponsiveContainer>
  );
}

export default PersonaSelectionPage;